import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import FormButton from '@components/form/form-button';
import { theme as antdTheme } from 'antd';

import { Modal, ModalContent, ModalTitle } from '@components/modal';

const { screenSMMax } = antdTheme.getDesignToken();

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media only screen and (max-width: ${screenSMMax}px) {
    flex-direction: column;
    gap: 12px;

    & > * {
      width: 100%;
    }
  }
`;

const RadioGroup = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-top: 16px;
`;

const Radio = styled.input`
  width: 2em;
  height: 2em;
  accent-color: ${({ theme }) => theme.primary};
  margin-right: 1em;
`;

const GrayText = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.textSecondary};
`;

interface MultipleRegistrationModalProps {
  open: boolean;
  closeModal: () => void;
  onProceed: () => void;
}

function MultipleRegistrationModal({
  open,
  closeModal,
  onProceed
}: MultipleRegistrationModalProps) {
  const [isSelected, setIsSelected] = useState(0);
  const intl = useIntl();
  return (
    <Modal open={open} onCancel={closeModal} footer={null}>
      <ModalTitle>
        {intl.formatMessage({ id: 'SELECT_NUMBER_OF_REGISTRANTS' })}
      </ModalTitle>
      <ModalContent style={{ whiteSpace: 'break-spaces' }}>
        {intl.formatMessage({ id: 'SELECT_NUMBER_OF_REGISTRANTS_DESC' })}
        {[2, 3, 4, 5].map((n) => (
          <RadioGroup key={n}>
            <Radio
              type="radio"
              checked={isSelected === n}
              onChange={() => setIsSelected(n)}
            />
            <GrayText onClick={() => setIsSelected(n)}>{n}</GrayText>
          </RadioGroup>
        ))}
      </ModalContent>
      <ButtonContainer>
        <FormButton withLeftArrow variant="outlined" onClick={closeModal}>
          {intl.formatMessage({ id: 'CANCEL' })}
        </FormButton>
        <FormButton
          withRightArrow
          type="primary"
          disabled={!isSelected}
          onClick={() => {
            if (isSelected) onProceed();
          }}
        >
          {intl.formatMessage({ id: 'PROCEED' })}
        </FormButton>
      </ButtonContainer>
    </Modal>
  );
}

export default MultipleRegistrationModal;
